import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrophoneOff = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4375 6.75006C12.3593 6.73555 12.2789 6.73713 12.2013 6.7547C12.1237 6.77227 12.0506 6.80546 11.9862 6.85224C11.9219 6.89903 11.8678 6.95843 11.8271 7.02683C11.7865 7.09522 11.7603 7.17118 11.75 7.25005C11.6257 8.05329 11.2491 8.79617 10.6748 9.3713C10.1004 9.94643 9.35806 10.324 8.55499 10.4494L7.375 12.1013V13H8.62499V11.6875C9.7114 11.5526 10.7229 11.063 11.5027 10.2946C12.2824 9.52615 12.7867 8.52187 12.9375 7.43755C12.9576 7.2808 12.917 7.12229 12.824 6.99448C12.7311 6.86667 12.5928 6.77923 12.4375 6.75006Z",
			fill: "#FF1E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.07501 10.3707C6.36269 10.1933 5.71941 9.80764 5.22735 9.26292C4.73529 8.7182 4.41678 8.03916 4.31252 7.31254C4.30247 7.22539 4.27477 7.14119 4.2311 7.0651C4.18743 6.989 4.1287 6.92261 4.05852 6.86997C3.98833 6.81733 3.90815 6.77954 3.82287 6.75893C3.73759 6.73831 3.64901 6.73529 3.56252 6.75005C3.4072 6.77922 3.26891 6.86667 3.17596 6.99448C3.08301 7.12229 3.04243 7.28079 3.06253 7.43754C3.19459 8.33452 3.56881 9.17848 4.1449 9.87857C4.72099 10.5787 5.47712 11.1084 6.33188 11.4106L7.07501 10.3707Z",
			fill: "#FF1E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.8838 9.23809L10.5 5.57561V5.49999C10.5 4.83695 10.2366 4.20107 9.76781 3.73223C9.29897 3.26339 8.66309 3 8.00005 3C7.33701 3 6.70113 3.26339 6.23229 3.73223C5.76345 4.20107 5.50006 4.83695 5.50006 5.49999V6.74998C5.50241 7.39131 5.75114 8.0072 6.19482 8.4703C6.63849 8.9334 7.24316 9.20828 7.8838 9.23809Z",
			fill: "#FF1E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.87504 13C4.76027 12.9999 4.64774 12.9682 4.5498 12.9084C4.45186 12.8485 4.37228 12.7629 4.31979 12.6608C4.26731 12.5588 4.24394 12.4442 4.25225 12.3297C4.26057 12.2153 4.30024 12.1053 4.36692 12.0119L10.6169 3.26193C10.7132 3.127 10.8592 3.03585 11.0227 3.00854C11.1862 2.98123 11.3538 3.01999 11.4888 3.1163C11.6237 3.21261 11.7148 3.35857 11.7421 3.52208C11.7694 3.68558 11.7307 3.85324 11.6344 3.98817L5.38442 12.7381C5.32653 12.8192 5.2501 12.8853 5.16149 12.9308C5.07289 12.9764 4.97467 13.0001 4.87504 13Z",
			fill: "#FF1E5F"
		})
	]
});
const ForwardRef = forwardRef(SvgMicrophoneOff);
export default ForwardRef;
